<wr-base-dialog status="warning" [header]="title">
  {{ message }}
</wr-base-dialog>
